import { useQuery } from '@tanstack/react-query';
import { QUERY_BASE_KEY } from '@constants/query-key';
import type { WeeklyOffSettingConfig } from '@vTypes/weeklyOff';
import axios from 'axios';
import { useEffect } from 'react';
import { weeklyOffSetting } from '@api/nurses';

/**
 * 주휴 설정 조회
 * @param isAdmin - 관리자 여부. true이면 groupId를 사용하여 조회
 * @param groupId - 관리자가 조회할 그룹의 ID.
 * @returns 
 */
export const useWeeklyOffSettingsQuery = ({ isAdmin, groupId }: { isAdmin: boolean; groupId?: string }) => {
    // 관리자인 경우에는 groupId가 필수
    const isQueryEnabled = isAdmin ? !!groupId : true;
    const queryId = isAdmin ? groupId : undefined;

    const query = useQuery<WeeklyOffSettingConfig, Error>({
        queryKey: [QUERY_BASE_KEY.WEEKLYOFF, 'settings', queryId],
        queryFn: () => weeklyOffSetting(queryId),
        staleTime: 5 * 60 * 1000,
        enabled: isQueryEnabled,
    });

    useEffect(() => {
        if (query.error) {
            console.error("주휴 설정 조회 중 에러 발생:", query.error);
            // TODO : 여기 이 에러 처리안해도됨
            if (axios.isAxiosError(query.error) && query.error.response?.status === 401) {
                // TODO : 일단 401에러만 적용함
                window.location.href = '/login';
            }
        }
    }, [query.error]);

    return query;
}
